
<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "NetSuite AI Powered Financial Assistant",



  extends: View,

  mixins: [LoadSections(["financial-assistant", "info"])],

  props: {
    id: {
      type: String,
      default: "NetSuite AI Powered Financial Assistant",
    },
  },
};
</script>
